import store from '@/store/index.js'
import { groupBy } from 'lodash'
import { exportCSVFile } from '@/utils/CSVUtility.js'
import moment from 'moment'

export async function exportTicketScaleSheetCSV (ticket) {
  const scaleInfo = await store.dispatch('scale-data/fetchScaleDataForTicket', ticket.ticketId)
  const segmentsGrouped = groupBy(scaleInfo.segmentVolumes, s => s.logNumber)
  const grossVolume = roundVolume(scaleInfo.segmentVolumes.reduce((acc, sv) => acc + sv.grossVolume, 0))
  const netVolume = roundVolume(scaleInfo.segmentVolumes.reduce((acc, sv) => acc + sv.netVolume, 0))
  const deductionVolume = blankOutColumn(roundVolume(grossVolume - netVolume))
  const csvItems = Object.entries(segmentsGrouped).map(([logNumber, segmentVolumes]) => {
    const hasSecondSegment = segmentVolumes.length > 1
    return {
      tract: ticket.tract,
      contractAccount: ticket.account,
      setting: ticket.setting,
      destination: ticket.destination,
      ticketNumber: ticket.ticketNumber,
      extTicketNumber1: ticket.extTicketNumber1,
      extTicketNumber2: ticket.extTicketNumber2,
      product: ticket.product,
      pieces: ticket.pieces,
      scaler: scaleInfo.scaledByUser,
      scaleDate: scaleInfo.scaledAt ? moment.utc(scaleInfo.scaledAt).toISOString() : '',
      grossVolume: grossVolume,
      deductionVolume: deductionVolume,
      netVolume: netVolume,
      weighedOutAt: ticket.weighedOutAt ? moment.utc(ticket.weighedOutAt).toISOString() : '',
      inWeight: ticket.inWeight,
      outWeight: ticket.outWeight,
      netWeight: ticket.inWeight - ticket.outWeight,
      trailerIdentifier: ticket.trailerIdentifier,
      logNumber: logNumber,
      speciesCode: segmentVolumes[0].speciesCode ?? '',
      species: segmentVolumes[0].species,
      logLength: segmentVolumes[0].length + (hasSecondSegment ? segmentVolumes[1].length : 0),
      logButtDiameter: segmentVolumes[0].buttLog ? (hasSecondSegment ? segmentVolumes[1].diameter : '') : '',
      buttCut: segmentVolumes[0].buttLog ? 'X' : '',
      logGrossVolume: roundVolume(segmentVolumes[0].grossVolume + (hasSecondSegment ? segmentVolumes[1].grossVolume : 0)),
      logDeductionVolume: blankOutColumn(roundVolume((segmentVolumes[0].grossVolume + (hasSecondSegment ? segmentVolumes[1].grossVolume : 0)) - (segmentVolumes[0].netVolume + (hasSecondSegment ? segmentVolumes[1].netVolume : 0)))),
      logNetVolume: roundVolume(segmentVolumes[0].netVolume + (hasSecondSegment ? segmentVolumes[1].netVolume : 0)),
      segmentOneGrade: segmentVolumes[0].grade,
      segmentOneEndUseSort: segmentVolumes[0].endUseSort ?? '',
      segmentOneLength: segmentVolumes[0].length ?? '',
      segmentOneTopDiameter: segmentVolumes[0].diameter ?? '',
      segmentOneGrossVolume: segmentVolumes[0].grossVolume ?? '',
      segmentOneDeductionVolume: blankOutColumn(roundVolume((segmentVolumes[0].grossVolume ?? 0) - (segmentVolumes[0].netVolume ?? 0))),
      segmentOneNetVolume: segmentVolumes[0].netVolume ?? '',
      segmentTwoGrade: hasSecondSegment ? segmentVolumes[1].grade ?? '' : '',
      segmentTwoEndUseSort: hasSecondSegment ? segmentVolumes[1].endUseSort ?? '' : '',
      segmentTwoLength: hasSecondSegment ? segmentVolumes[1].length ?? '' : '',
      segmentTwoTopDiameter: hasSecondSegment ? segmentVolumes[1].diameter ?? '' : '',
      segmentTwoGrossVolume: hasSecondSegment ? segmentVolumes[1].grossVolume ?? '' : '',
      segmentTwoDeductionVolume: hasSecondSegment ? blankOutColumn(roundVolume((segmentVolumes[1].grossVolume ?? 0) - (segmentVolumes[1].netVolume ?? 0))) : '',
      segmentTwoNetVolume: hasSecondSegment ? segmentVolumes[1].netVolume ?? '' : ''
    }
  })
  const headers = Object.keys(csvItems[0]).map(key => csvHeaders[key] || key)
  exportCSVFile(headers, csvItems, `ScaleSheet_${ticket.ticketNumber}_${moment().format('YYYYMMDD_HHmmss')}`)
}

const blankOutColumn = columnData => columnData === 0 ? '' : columnData

const roundVolume = volume => Number(volume.toFixed(3))

const csvHeaders = {
  tract: 'Tract',
  contractAccount: 'ContractAccount',
  setting: 'Setting',
  destination: 'Destination',
  ticketNumber: 'TicketNumber',
  extTicketNumber1: 'ExtTicketNum1',
  extTicketNumber2: 'ExtTicketNum2',
  product: 'Product',
  pieces: 'Pieces',
  scaler: 'Scaler',
  scaleDate: 'ScaleDate',
  grossVolume: 'GrossVolume',
  deductionVolume: 'DeductionVolume',
  netVolume: 'NetVolume',
  weighedOutAt: 'WeighedOutAt',
  inWeight: 'InWeight',
  outWeight: 'OutWeight',
  netWeight: 'NetWeight',
  trailerIdentifier: 'TrailerIdentifier',
  logNumber: 'LogNumber',
  speciesCode: 'SpeciesCode',
  species: 'Species',
  logLength: 'LogLength',
  logButtDiameter: 'LogButtDiameter',
  buttCut: 'ButtCut',
  logGrossVolume: 'LogGrossVolume',
  logDeductionVolume: 'LogDeductionVolume',
  logNetVolume: 'LogNetVolume',
  segmentOneGrade: 'SegmentOneGrade',
  segmentOneEndUseSort: 'SegmentOneEndUseSort',
  segmentOneLength: 'SegmentOneLength',
  segmentOneTopDiameter: 'SegmentOneTopDiameter',
  segmentOneGrossVolume: 'SegmentOneGrossVolume',
  segmentOneDeductionVolume: 'SegmentOneDeductionVolume',
  segmentOneNetVolume: 'SegmentOneNetVolume',
  segmentTwoGrade: 'SegmentTwoGrade',
  segmentTwoEndUseSort: 'SegmentTwoEndUseSort',
  segmentTwoLength: 'SegmentTwoLength',
  segmentTwoTopDiameter: 'SegmentTwoTopDiameter',
  segmentTwoGrossVolume: 'SegmentTwoGrossVolume',
  segmentTwoDeductionVolume: 'SegmentTwoDeductionVolume',
  segmentTwoNetVolume: 'SegmentTwoNetVolume'
}
